export function findAttrInNodeTree<AttributeValue>(
  node: Node,
  getAttr: (node: Node) => AttributeValue | undefined | null
) {
  const attribute = getAttr(node);
  if (!attribute && node.parentElement) {
    return findAttrInNodeTree(node.parentElement, getAttr);
  }
  return attribute;
}
